import { RouteEnum } from "../enums/RouteEnum";

export const isRefurbishedRoute = (pathname: string): boolean =>
    pathname === RouteEnum.REFURBISHED ||
    pathname.startsWith(`${RouteEnum.REFURBISHED}/`);
